import {
  HOME_CARE_ROS_OPTIONS,
  HOME_CARE_ROS_SAFETY_ASSESSMENT,
  HOME_CARE_ROS_SAFETY_QUESTIONS,
} from "@/pages/app/admin/library/templates/home-care-ros/home-care-ros-data";
import { parseHomeCareRosOptions } from "@/pages/app/admin/library/templates/home-care-ros/home-care-ros-utils";
import { RosAndPe } from "../../encounter-constant";

const SAFETY_ANSWER_KEYS = HOME_CARE_ROS_SAFETY_QUESTIONS.flatMap(
  (question) => [
    question.key,
    ...(question.followUps?.map((followUp) => followUp.key) ?? []),
  ]
);

const getTokenLabel = (token: string): string => token.split(":")[0].trim();

/** Saved items carry no home-care marker, so match the description against the system's catalog. */
export const isHomeCareItem = ({
  templateNameType,
  description,
}: RosAndPe): boolean => {
  if (!templateNameType || !description) return false;
  const tokens = description.split(",");
  if (templateNameType === HOME_CARE_ROS_SAFETY_ASSESSMENT) {
    return tokens.every((token) =>
      SAFETY_ANSWER_KEYS.includes(getTokenLabel(token))
    );
  }
  const catalog = HOME_CARE_ROS_OPTIONS[templateNameType];
  if (!catalog) return false;
  const labels = parseHomeCareRosOptions(catalog).map((it) => it.label);
  return tokens.every((token) => labels.includes(getTokenLabel(token)));
};
